import { Component } from '@angular/core';
import { environment } from '../../../environment/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.css',
    standalone: false
})
export class FooterComponent {
  public version = environment.version;
}
